module.exports = __webpack_public_path__ + "static/media/avatars_female_6.716c867a.png";